// src/components/ResourceManager/Hardware/HardwareTableColumns.ts

import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";


// Icons
import { ReactComponent as IconEye } from "../../../../../shared/assets/Icons/Icon_Eye.svg";
import { ReactComponent as IconEdit } from "../../../../../shared/assets/Icons/Icon_Edit.svg";

/**
 * Props que recibe getHardwareColumns para definir las acciones.
 */
export interface CustomerTableRow {
	id: number;
	displayName: string;
	name: string;
	chargebeeCustomerId: string | null;
}

/**
 * Props que recibe getCustomerColumns para definir las acciones.
 */
interface CustomerColumnsProps {
    handleViewCustomer: (c: CustomerTableRow) => void;
    handleEditCustomer: (c: CustomerTableRow) => void;
    handleDeleteClick: (c: CustomerTableRow) => void;
}

/**
 * Retorna las columnas de la tabla para Customers.
 */
export function getCustomerColumns({
    handleViewCustomer,
    handleEditCustomer,
    // handleDeleteClick,
}: CustomerColumnsProps): GenericTableColumn<CustomerTableRow>[] {
    return [
        {
            header: "ID",
            accessor: "id",
        },
        {
            header: "Customer Name",
            accessor: "displayName",
        },
        {
            header: "Name",
            accessor: "name",
        },
        {
            header: "Chargebee Customer ID",
            accessor: "chargebeeCustomerId",
            renderCell: (row) => row.chargebeeCustomerId || "-",
        },
        {
            header: "Actions",
            accessor: "id",
            renderCell: (row) => (
                <div className="flex items-center gap-2">
                    {/* View */}
                    <button
                        className="
              flex items-center justify-center
              border border-semantic-border-secondary
              rounded
              text-semantic-text-secondary
              hover:bg-semantic-state-active
              w-10 h-10
            "
                        onClick={() => handleViewCustomer(row)}
                    >
                        <IconEye className="w-6 h-6" />
                    </button>

                    {/* Edit */}
                    <button
                        className="
              flex items-center justify-center
              border border-semantic-border-secondary
              rounded
              text-semantic-text-secondary
              hover:bg-semantic-state-active
              w-10 h-10
            "
                        onClick={() => handleEditCustomer(row)}
                    >
                        <IconEdit className="w-10 h-10" />
                    </button>
                </div>
            ),
        },
    ];
}
